export const doubleSelector =
  (f: (...args: any[]) => any) => (state: RootState) =>
    f(state)(state);
